import { flatten } from 'util/flatten';

import { DepartmentModel } from 'api/dto/Department.dto';

const handleItem = (item: DepartmentModel, result: any[] = []) => {
  result.push(item);

  item.children.forEach((child) => {
    handleItem(child, result);
  });

  return result;
};

export const treeToFlatList = (tree: DepartmentModel[]) =>
  flatten(tree.map((item) => handleItem(item)));
